import { IndividualResult } from '../classroom.constants';

export function sortIndividualResults<T extends IndividualResult>(
  students: T[]
) {
  students.sort((a, b) => {
    if (a.isPending !== b.isPending) {
      return a.isPending ? 1 : -1;
    }

    if (a.isCorrect !== b.isCorrect) {
      return a.isCorrect ? -1 : 1;
    }

    if (a.attempts !== b.attempts) {
      return a.attempts - b.attempts;
    }

    return a.studentName.localeCompare(b.studentName);
  });

  return students;
}
